export default function WarningBlocks({ count }: { count: number }) {
  // If they have no warnings, we don't render anything
  if (count === 0) return null

  return (
    <div className="flex items-center gap-1 mt-2" title={`${count}/3 Warnings`}>
      {/* Block 1: Yellow on 1st warning */}
      <div className={`w-4 h-4 rounded-sm border ${count >= 1 ? 'bg-amber-500 border-amber-400 shadow-[0_0_8px_rgba(245,158,11,0.5)]' : 'bg-slate-800 border-slate-700'}`}></div>
      
      {/* Block 2: Red on 2nd warning */}
      <div className={`w-4 h-4 rounded-sm border ${count >= 2 ? 'bg-red-500 border-red-400 shadow-[0_0_8px_rgba(239,68,68,0.5)]' : 'bg-slate-800 border-slate-700'}`}></div>
      
      {/* Block 3: Black/Dark on 3rd warning (Banned) */}
      <div className={`w-4 h-4 rounded-sm border ${count >= 3 ? 'bg-black border-red-600 shadow-[0_0_8px_rgba(0,0,0,0.8)]' : 'bg-slate-800 border-slate-700'}`}></div>
    </div>
  )
}
